import React from 'react';

const blurOnEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
        const target = event.target as any;

        if (target.blur) {
            target.blur();

            event.stopPropagation();
            event.preventDefault();

            return false;
        }
    }

    return true;
};

export default blurOnEnter;
